var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowUp = function SvgArrowUp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "16px",
    viewBox: "0 0 26 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "88D7ECB3-FD21-45B7-BC97-95E39077FADF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DS_Suez_PCE_Atoms",
    transform: "translate(-261.000000, -563.000000)",
    fill: "#030F40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets-/-Icons-/-Bold-/-Arrow-/-arrow-up-1",
    transform: "translate(261.000000, 563.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,0.499998235 C13.6617023,0.499181025 14.2917013,0.783391099 14.729,1.28 L24.54,12.43 C24.9941571,12.9227439 25.1458017,13.6228213 24.9362535,14.2593312 C24.7267052,14.8958411 24.18884,15.3689219 23.5307895,15.495511 C22.872739,15.6221001 22.1977441,15.3823369 21.767,14.869 L13.188,5.119 C13.1405308,5.06484525 13.0720143,5.03379078 13,5.03379078 C12.9279857,5.03379078 12.8594692,5.06484525 12.812,5.119 L4.233,14.871 C3.80225592,15.3843369 3.127261,15.6241001 2.4692105,15.497511 C1.81116,15.3709219 1.27329478,14.8978411 1.06374654,14.2613312 C0.854198302,13.6248213 1.00584286,12.9247439 1.46,12.432 L11.268,1.284 C11.7060475,0.786188972 12.3369004,0.500629665 13,0.499998235 Z",
    id: "icon-fill-color"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-up.f491607e819836894c1387373e8f80a5.svg";